module.exports = __webpack_public_path__ + "static/media/purchaseActive.b8f45065.png";